import { useSite } from '@labradorsports/utils';

import { useLoadEntityLogoQuery } from '../../store/index.js';

interface Props {
    program: Program;
    fallbackToSiteLogo?: boolean;
}

const ProgramLogo: FC<Props> = ({ program, fallbackToSiteLogo = false }) => {
    const { Icons } = useSite();
    const { data: programLogoUrl } = useLoadEntityLogoQuery({ programId: program?.id });

    const logo = programLogoUrl ? (
        <img src={programLogoUrl} alt={program?.name || 'Program Logo'} className="img-fluid" />
    ) : (
        <Icons.Logo className="img-fluid" />
    );
    const fallbackLetter = program?.name ? program.name.charAt(0).toUpperCase() : '?';

    return (
        <div className="program-logo">
            {programLogoUrl || fallbackToSiteLogo ? logo : <span className="team-letter">{fallbackLetter}</span>}
        </div>
    );
};

export default ProgramLogo;
